<template>
  <el-form
    :model="form"
    :rules="rules"
    :validateOnRuleChange="false"
    ref="form"
    label-width="100px"
  >
    <el-form-item :label="$t('tech_name')" prop="name" :error="errors.name">
      <el-input class="el-input--wmd" v-model="form.name"></el-input>
    </el-form-item>
    <el-form-item :label="$t('tech_type')" prop="type" :error="errors.type">
      <el-checkbox-group v-model="form.type">
        <el-checkbox
          v-for="item in $store.state.app.configs.techTypes"
          :label="item"
          :key="item"
          >{{ $t(`tech_type_${item}`) }}</el-checkbox
        >
      </el-checkbox-group>
    </el-form-item>
    <el-form-item
      :label="$t('tech_description')"
      prop="description"
      :error="errors.description"
    >
      <el-input v-model="form.description" type="textarea" :rows="3"></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('tech_advantages')"
      prop="advantages"
      :error="errors.advantages"
    >
      <el-input
        v-model="form.advantages"
        type="textarea"
        :rows="3"
        :placeholder="$t('tech_advantages_placeholder')"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('tech_market')"
      prop="market"
      :error="errors.market"
    >
      <el-input class="el-input--wmd" v-model="form.market"></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('readiness')"
      prop="readiness"
      :error="errors.readiness"
    >
      <el-radio-group v-model="form.readiness">
        <el-radio
          v-for="item in $store.state.app.configs.readinesses"
          :label="item"
          :key="item"
          >{{ $t(`readiness_${item}`) }}</el-radio
        >
      </el-radio-group>
    </el-form-item>
    <el-form-item
      :label="$t('references')"
      prop="references"
      :error="errors.references"
    >
      <el-input
        v-model="form.references"
        type="textarea"
        :rows="3"
        :placeholder="$t('tech_references_placeholder')"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('gallery')"
      prop="gallery"
      ref="gallery"
      :error="errors.gallery"
    >
      <file-upload
        :action="$store.state.app.configs.uploadServiceUrl + '?cat=temp'"
        :data="{ category: 'temp' }"
        v-model="form.gallery"
        list-type="picture-card"
        :limit="3"
        :tip="$t('upload_tip', ['2MB', '3'])"
        :maxSize="2000"
        accept=".jpg, .jpeg, .png, .gif, .svg"
      ></file-upload>
    </el-form-item>
  </el-form>
</template>

<script>
import { lengthValidator } from '@/utils/validators';

import FileUpload from '@/components/public/file-upload';

export default {
  name: 'Tech',
  components: {
    FileUpload,
  },
  props: {
    value: Object,
  },
  watch: {
    value(newVal) {
      this.form = newVal;
    },
  },
  data() {
    return {
      form: {
        name: '',
        type: [],
        description: '',
        advantages: '',
        market: '',
        readiness: '',
        references: '',
        gallery: [],
      },
      errors: {
        name: null,
        type: null,
        description: null,
        advantages: null,
        market: null,
        readiness: null,
        references: null,
        gallery: null,
      },
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 50,
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
          },
        ],
        description: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 50,
            max: 300,
            trigger: 'blur',
          },
        ],
        advantages: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 50,
            max: 300,
            trigger: 'blur',
          },
        ],
        market: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 100,
            trigger: 'blur',
          },
        ],
        readiness: [
          {
            required: true,
          },
        ],
        references: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 50,
            max: 600,
            trigger: 'blur',
          },
        ],
        gallery: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 3,
            trigger: 'change',
          },
        ],
      };
    },
  },
  methods: {
    async validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve({ valid, data: this.form });
        });
      });
    },
  },
  created() {
    if (this.value) {
      this.form = this.value;
    }
  },
};
</script>
